import ListingUrlFormatter from './formatters/ListingUrlFormatter';

/**
 * Generates listing page URL
 *
 * @example
 * toURL({
 *  baseUrl: '/vacation-rental/p4587083',
 *  adultsCount: 1,
 *  childrenCount: 2,
 * });
 * // returns
 * // '/vacation-rental/p4587083?adultsCount=1&childrenCount=2'
 * @param {object} listingRequest - Listing Request model
 * @returns {string} listing page relative URL
 */
export default function toURL(listingRequest) {
    return new ListingUrlFormatter().format(listingRequest);
}
